'use client';

import { cn } from '@/lib/utils';

interface StyledIconProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  /** Tailwind background color class for the image (e.g., 'bg-blue-500 hover:bg-red-500 group-hover:bg-green-500') */
  bgClassName?: string;
}

/**
 * Icon/Image component that supports background color masking with hover and group-hover states
 */
export const StyledIcon = ({ src, width = 16, height = 16, className = '', bgClassName: tintColor = 'bg-foreground' }: StyledIconProps) => {
  return (
    <div
      className={cn('relative', className)}
      style={{ width, height }}
    >
      <div
        className={cn('absolute inset-0', tintColor)}
        style={{
          maskImage: `url('${src}')`,
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          WebkitMaskImage: `url('${src}')`,
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};
StyledIcon.displayName = 'StyledImage';
